import { DatePipe } from "@angular/common";
import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { CommonService } from "../_services/app.common.service";

@Pipe({
  name: 'date'
})
export class ExtendDatePipe extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string, private common: CommonService) {

    super(locale);
  }


  transform(value: Date | string | number, format?: string | boolean): string | null;
  transform(value: null | undefined, format?: string | boolean): null;
  transform(value: Date | string | number | null | undefined, format?: string, appendTime?: boolean | string): string | null;


  transform(value: Date | string | number | null | undefined, format?: string, appendTimeOrTimeFormat?: string | boolean): string | null {
    if (this.common.isNullOrWhiteSpace(format))
      format = this.common.GetDateFormat();
    if (this.common.isNullOrWhiteSpace(format))
      format = "dd/MM/yyyy";
    if (typeof (appendTimeOrTimeFormat) == "boolean" && appendTimeOrTimeFormat)
      format = format + " hh:mm"
    if (typeof (appendTimeOrTimeFormat) == "string" && !this.common.isNullOrWhiteSpace(appendTimeOrTimeFormat))
      format = format + " " + appendTimeOrTimeFormat?.toString();

    return super.transform(value, format);
  }





}
